import { isPlatformServer } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { Environment } from '../interfaces/env';
import { BrowserService } from '../services/browser.service';
@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  private browserService = inject(BrowserService);
  private platformId = inject(PLATFORM_ID);
  private _apiEndpoint = 'https://api.picflow.io/v1';
  public socketEndpoint = 'wss://api.picflow.io';
  public intercomAppId = 'xh9h3015';
  public assetsEndpoint = 'https://cdn.picflow.com/assets';
  public archivesEndpoint = 'https://cdn.picflow.com';
  public stripePublishableKey = 'pk_live_NtSGaeAq8LDmOSSwHttWC3fZ00xG0iIQGE';
  public customerIoSiteId = '3d7865fd575645fd048e';
  public env: Environment;
  public origin: string;
  public gtmWorkspaceId: string;
  public gtmEnvironmentExtra = '';
  public cioKey: string;
  public isTenantDomain: boolean;
  public customDomainCnameValue = 'domains.picflow.com';
  /** Clerk OAuth application client ID for the Lightroom Classic plugin (PKCE public client). */
  public lightroomAuthClientId = 'ZaPYnKHhgPYbrwMY';
  public growthBookKey = 'sdk-x2pTmLrnINzmK52';
  public correctPicflowUrl: string;
  public translationBase = '';
  public clerkKey = 'pk_live_Y2xlcmsucGljZmxvdy5jb20k';
  public storyblokBridgeUrl = 'https://app.storyblok.com/f/storyblok-v2-latest.js?t=Q2mIMuV6frKpnmQlOee0rAtt';
  public internalApiUrlBase = '/internal-api';
  public version = '2.0.3-5faee9e57c01781b9ffe58ae27f1f8761ff8e65a';
  public captureOneLocalHost = 'http://localhost:9630';
  public wafEndpoint = 'https://f6f194e15014.edge.sdk.awswaf.com/f6f194e15014/a38e6277f2fd/challenge.js';
  public storyblokUrl = 'https://cdn.picflow.com/web';
  public appsyncEndpoint = 'events.api.picflow.io';

  constructor() {
    this.loadConfig();
  }

  private loadConfig() {
    this.env = this.browserService.getEnv() || 'local';
    this.origin = this.browserService.getOrigin() || 'http://localhost:4200';

    if (this.env === 'local') {
      this.internalApiUrlBase = 'https://dev.picflow.com/internal-api';
      // this.internalApiUrlBase = 'http://localhost:3000/internal-api';
    } else {
      // its important to keep this one here, as it is used for cloudwatch log metrics
      console.debug('env:', this.env, 'origin:', this.origin);
    }

    if (this.env === 'local' || this.env === 'dev') {
      // Local and dev overrides
      this.customDomainCnameValue = 'domains.dev.picflow.com';
      this._apiEndpoint = 'https://dev.picflow.com/api/v1'; // 'https://api.dev.picflow.io/v1'
      this.socketEndpoint = 'wss://api.dev.picflow.io';
      this.intercomAppId = 'e6ygvgd5';
      this.assetsEndpoint = 'https://cdn.dev.picflow.com/assets';
      this.archivesEndpoint = 'https://cdn.dev.picflow.com';
      this.stripePublishableKey = 'pk_test_DryYoD7xsvd3p16oEn1s3pkJ00MLYT9HqZ';
      this.customerIoSiteId = '5ca3ffa72c4602a525a6';
      this.lightroomAuthClientId = 'y6Mf7fhkSWgWi9Vy';
      this.clerkKey = 'pk_test_cmVsYXhpbmctc2F0eXItNTUuY2xlcmsuYWNjb3VudHMuZGV2JA';
      this.growthBookKey = 'sdk-eQfRi8byGUgyJ';
      this.wafEndpoint = 'https://92f0a861889c.edge.sdk.awswaf.com/92f0a861889c/92d5ecba3d52/challenge.js';
      this.storyblokUrl = 'https://cdn.dev.picflow.com/web';
      this.appsyncEndpoint = 'events.api.dev.picflow.io';
    }

    this.correctPicflowUrl = this.browserService.getCorrectPicflowUrl();

    if (this.browserService?.isTenantDomain()) {
      this.isTenantDomain = true;
      // Tenant domains (all environments) — no Picflow GTM here, only CIO
      this.cioKey = '73273b9331c06c6a7a35';

      if (this.env !== 'production') {
        this.cioKey = '556a9056690697f05a5d';
      }
    } else {
      this.isTenantDomain = false;
      // Main domain (all environments)
      this.gtmWorkspaceId = 'GTM-WNDQZLB';
      this.cioKey = 'd93b58caf644d2d4fd9b';

      if (this.env !== 'production') {
        this.cioKey = 'ee7c8b94385220ba70ea';
        // On local, dev and test we load the "test" environment of this gtm workspace
        this.gtmEnvironmentExtra = '&gtm_auth=09Biw7nYhdMffj2og8K2fQ&gtm_preview=env-3&gtm_cookies_win=x';
      }
    }
  }

  public get apiEndpoint() {
    if (isPlatformServer(this.platformId)) return this._apiEndpoint;
    if (this.browserService.isExtension()) return this._apiEndpoint;
    if (this.env === 'local') return this._apiEndpoint;
    return `/api/v1`;
  }
}
